import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode, useCallback, useState } from "react";
import { useClick } from "../../util/handlers";

interface DropDownProps {
  title: string | ReactNode;
  chevron?: boolean;
  className?: string;
  children: ReactNode;
}

export const DropDownButton = ({
  title,
  chevron = false,
  className = "",
  children,
}: DropDownProps) => {
  const [open, setOpen] = useState(false);
  const onOpen = useClick(() => setOpen(!open), [open]);
  const delayedClose = useCallback(() => setTimeout(setOpen, 200, false), []);
  return (
    <div>
      <button
        className={`inline-flex items-center ${className}`}
        onClick={onOpen}
        onBlur={delayedClose}
      >
        <span>{title}</span>
        {chevron && (
          <div className="bg-light-gray rounded-sm ml-2 h-6 w-6 text-dark font-normal group-hover:font-medium">
            <FontAwesomeIcon
              icon={open ? faChevronUp : faChevronDown}
              fill="currentColor"
              aria-hidden="true"
            />
          </div>
        )}
      </button>
      {open ? children : null}
    </div>
  );
};
